import { DEF, I_ADDRS, Q_ADDRS } from "../../plc-sim/library";
import { store, useTick } from "../../plc-sim/store";

function useRows() {
  const project = store.project;
  const plc = project.devices.find((d) => d.type === "plc");
  const link = (addr: string) => {
    if (!plc) return null;
    const key = `${plc.id}:${addr}`;
    const w = project.wires.find((x) => x.from === key || x.to === key);
    if (!w) return null;
    const other = w.from === key ? w.to : w.from;
    const [id, term] = other.split(":");
    const d = project.devices.find((x) => x.id === id);
    if (!d) return null;
    return { device: d, term: term ?? "", typeName: DEF[d.type]?.name ?? d.type };
  };
  return { plc, link };
}

export function IoMapping({ onFocus }: { onFocus?: (deviceId: string) => void }) {
  useTick();
  const { link } = useRows();

  const Row = ({ addr, kind }: { addr: string; kind: "Input" | "Output" }) => {
    const l = link(addr);
    const on = store.mem.bit(addr);
    return (
      <tr className="border-b border-border/60">
        <td className="px-2 py-1 font-mono text-[11px]">{addr}</td>
        <td className="px-1 py-1">
          <input
            className="sim-input w-full text-[11px]"
            placeholder="—"
            value={store.tag(addr)}
            onChange={(e) => store.setTag(addr, e.target.value)}
          />
        </td>
        <td className="px-2 py-1 text-[11px] text-muted-foreground">{kind}</td>
        <td className="px-2 py-1 text-[11px]">
          {l ? (
            <button className="underline-offset-2 hover:underline" onClick={() => onFocus?.(l.device.id)}>
              {l.device.label}
            </button>
          ) : (
            <span className="text-muted-foreground">—</span>
          )}
        </td>
        <td className="px-2 py-1 font-mono text-[11px]">{l?.term ?? "—"}</td>
        <td className="px-2 py-1">
          <span
            className="rounded px-1.5 py-0.5 font-mono text-[10px] text-white"
            style={{ background: on ? "var(--lad-live)" : "#7f8b96" }}
          >
            {on ? "ON" : "OFF"}
          </span>
        </td>
      </tr>
    );
  };

  return (
    <div className="overflow-auto" dir="rtl">
      <table className="w-full border-collapse text-right">
        <thead className="sticky top-0 bg-card">
          <tr className="border-b border-border text-[10px] text-muted-foreground">
            <th className="px-2 py-1 font-medium">Address</th>
            <th className="px-2 py-1 font-medium">Name</th>
            <th className="px-2 py-1 font-medium">Type</th>
            <th className="px-2 py-1 font-medium">Component</th>
            <th className="px-2 py-1 font-medium">Terminal</th>
            <th className="px-2 py-1 font-medium">State</th>
          </tr>
        </thead>
        <tbody>
          {I_ADDRS.map((a) => (
            <Row key={a} addr={a} kind="Input" />
          ))}
          {Q_ADDRS.map((a) => (
            <Row key={a} addr={a} kind="Output" />
          ))}
        </tbody>
      </table>
    </div>
  );
}
